import React from 'react';
import CategoryButton from '../../CategoryButton.js';
import { getIconForCategory } from '../../AppUtils.js';
import { SUBCATEGORIES, isCompulsoryCategory } from '../../constants.js';

const CategoryNavigation = ({
  loading,
  error,
  viewState,
  onBack,
  categoryScrollRef,
  categoryScrollState,
  shouldShowArrows,
  scrollCategoriesLeft,
  scrollCategoriesRight,
  categories,
  selectedCategory,
  onCategoryClick,
  categoryConfig,
  selectedMainCategory,
  compulsoryData
}) => {
  if (loading) {
    return (
      <div className="mb-0.5 lg:mb-1.5 h-[50px] lg:h-[56px] flex items-center flex-shrink-0">
        <div className="flex items-center justify-center h-full w-full">
          <div className="text-gray-600 text-sm">Loading categories...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="mb-0.5 lg:mb-1.5 h-[50px] lg:h-[56px] flex items-center flex-shrink-0">
        <div className="flex items-center justify-center h-full w-full">
          <div className="text-gray-600 text-sm">Categories unavailable</div>
        </div>
      </div>
    );
  }

  const renderButtons = () => {
    return categories.map((categoryName, index) => {
      const safeCategoryName = categoryName || `Category ${index + 1}`;
      const isSelected = safeCategoryName === selectedCategory;

      // Determine display name and icon
      let displayName = safeCategoryName;
      let icon = getIconForCategory(safeCategoryName, categoryConfig);

      // Handle General subcategory special case
      if (viewState === 'sub' && safeCategoryName === SUBCATEGORIES.GENERAL) {
        displayName = selectedMainCategory; // Show parent category name
        icon = getIconForCategory(safeCategoryName, categoryConfig, selectedMainCategory);
      }

      // Check if category is compulsory
      const isCompulsory = isCompulsoryCategory(safeCategoryName, compulsoryData);

      return (
        <CategoryButton
          key={index}
          categoryName={safeCategoryName}
          displayName={displayName}
          isSelected={isSelected}
          onClick={onCategoryClick}
          icon={icon}
          isCompulsory={isCompulsory}
        />
      );
    });
  };

  // Check scroll states for each direction
  const { canScrollLeft, canScrollRight } = categoryScrollState;

  return (
    <div className="category-bar-black h-[50px] md:h-[56px] lg:h-[94px] flex items-center flex-shrink-0 relative -mx-1 lg:-mx-2.5">
      {canScrollLeft && (
        <button
          onClick={scrollCategoriesLeft}
          className="hidden md:flex absolute left-0 z-10 w-6 h-[38px] lg:h-[80px] rounded items-center justify-center transition-all duration-200 hover:bg-white/30"
        >
          <img
            src="/images/icons/arrowicon.svg"
            alt="Previous"
            className="w-5 h-5 rotate-180 invert opacity-80"
          />
        </button>
      )}

      <div className={`flex-1 relative overflow-hidden h-full ${canScrollLeft ? 'md:pl-8' : 'pl-0'} ${canScrollRight ? 'md:pr-8' : 'pr-0'}`}>
        <div
          ref={categoryScrollRef}
          className="flex gap-1.5 overflow-x-auto overflow-y-hidden scrollbar-hide px-0.5 h-full items-center"
        >
          {viewState === 'sub' && (
            <button
              onClick={onBack}
              className="category-button-horizontal category-button-default"
              style={{ fontWeight: 700, textTransform: 'uppercase' }}
            >
              ← BACK
            </button>
          )}
          {renderButtons()}
        </div>
      </div>

      {canScrollRight && (
        <button
          onClick={scrollCategoriesRight}
          className="hidden md:flex absolute right-0 z-10 w-6 h-[38px] lg:h-[80px] rounded items-center justify-center transition-all duration-200 hover:bg-white/30"
        >
          <img
            src="/images/icons/arrowicon.svg"
            alt="Next"
            className="w-5 h-5 invert opacity-80"
          />
        </button>
      )}
    </div>
  );
};

export default CategoryNavigation;
